import React from "react";

export class FoodInfo extends React.Component {

  async componentDidMount() {}

  render() {
    return (
      <div className="FoodInfo">
        <div>
          <div
            className="Post"
            dangerouslySetInnerHTML={{ __html: this.props.foodPost }}
          />
        </div>
      </div>
    );
  }
}

export default FoodInfo;



// WEBPACK FOOTER //
// ./src/Components/Food/FoodInfo.js